import { useRemoteClientPost } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { useLocalStorage } from '@/remote/local-storage'
import { ComboSelectWithLabel } from '@/view/components/combo-select-with-label'
import { PaginationDemo } from '@/view/components/pagination'
import { TableExercise } from '@/view/components/table-exercise'
import { usePagination } from '@/view/hooks'
import { usePromiseToast } from '@/view/hooks/toast-promisse'
import { ExerciseFormData } from '@/view/validators/exercise-validator'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export function DisplayExercice() {
  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [data, setData] = useState<ExerciseFormData[]>([])
  const [params] = useSearchParams()
  const [controlPage, setControlPage] = useState(0)
  const [gruops, setGroups] = useState<any>([])
  const [selectGroup, setSelectGroup] = useState(null)

  const [pageInfo, setPageInfo] = useState({
    page: 1,
    total: 0,
    totalPages: 0
  })
  const quantityForPage = 10

  const getNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const getBackPage = () => {
    backPage(pageInfo.page, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const fetchData = async () => {
    try {
      const response = await httpClientPost(`${Endpoints.exercise}/filtro?page=${controlPage}&size=${quantityForPage}&order=desc&sort=id`, {
        idUnidade: params.get('id') ?? getUnitId(),
        idGrupo: selectGroup === 0 ? null : selectGroup
      })

      const data = response?.data?.data ?? {}
      const content = data?.content ?? []
      const page = data?.pageable?.pageNumber ?? 0
      const totalPages = data?.totalPages
      const total = data?.totalElements
      //console.log(page, totalPages, total)

      setData(content)
      setPageInfo({
        page: page,
        total: total,
        totalPages: totalPages
      })
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
    }
  }

  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  const fetchGroups = async (unidadeId: number) => {
    setGroups([])

    try {
      const response = await httpClientPost(`${Endpoints.gruops}/filtro?page=${0}&size=${100}&order=desc&sort=id`, {
        idUnidade: unidadeId
      })

      const data = response?.data?.data?.content || []
      setGroups([
        { label: 'Todos', value: 0 },
        ...data.map((elem: any) => ({
          ...elem,
          label: elem.nome,
          value: elem.id
        }))
      ])
    } catch (error) {
      console.error('Erro ao buscar dados de serviços:', error)
    }
  }

  useEffect(() => {
    fetchGroups(params.get('unit') || getUnitId())
  }, [params])

  useEffect(() => {
    handleRefresh()
  }, [controlPage, params, selectGroup])

  return (
    <>
      <div className="grid grid-cols-4 m-2">
        <ComboSelectWithLabel
          defaultValue={selectGroup}
          data={gruops}
          onChange={(e) => {
            setSelectGroup(e?.value)
          }}
        />
      </div>
      <TableExercise data={data} height=" h-[calc(100vh-450px)]" getRefreshList={handleRefresh} />
      <PaginationDemo totalForPage={quantityForPage} back={getBackPage} next={getNextPage} page={pageInfo.page} total={pageInfo.total} labelItem="Exercícios cadastrados" />
    </>
  )
}
